(function ($) {
    $(function () {
        $("#toTop").click(function () {
            $("html, body").animate({
                scrollTop: 0,
            });
            return false;
        });
        $(window).on("load scroll", function () {
            var $scrollTop = $(window).scrollTop();
            var $window = $(window);
            if ($(".onl-page-top").length) {
                var $stop01 = $(".onl-page-top").offset().top;
                if (
                    $scrollTop + $window.height() >=
                    $stop01 + $(".onl-page-top").height()
                ) {
                    $("#toTop").removeClass("active");
                } else {
                    $("#toTop").addClass("active");
                }
                if ($(this).scrollTop() > 20) {
                    $("#toTop").fadeIn("500");
                    $(".onl-popup").addClass("active");
                } else {
                    $("#toTop").fadeOut("500");
                    $(".onl-popup").removeClass("active");
                }
            }
        });
        const handleToggleNavSecond = () => {
            const nav = document.getElementById("jsMenu");
            const hamburger = document.getElementById("jsMenuButton");
            if (!nav || !hamburger) return;
            let isOpen = false;
            const closeMenu = () => {
                hamburger.classList.remove("active");
                isOpen = false;
            };
            hamburger.addEventListener("click", (e) => {
                e.stopPropagation();
                isOpen = !isOpen;
                hamburger.classList.toggle("active", isOpen);
            });
            document.addEventListener("click", closeMenu);
            nav.addEventListener("click", (e) => {
                e.stopPropagation();
                closeMenu();
            });
        };
        $("#jsMenuButton, #jsCloseMenu").on("click", function () {
            $(".header-onl__wrap").toggleClass("active");
            $("html").toggleClass("frozen");
        });
        $(".header-onl__nav a").on("click", function () {
            $(".header-onl__wrap").removeClass("active");
            $("html").removeClass("frozen");

            $(this)
                .addClass("active")
                .parent()
                .siblings()
                .find("a")
                .removeClass("active");
        });
        $(window).on("load", function () {
            handleToggleNavSecond();
        });
    });
})(jQuery);
